import { MrPlayPauseToggle } from '@mrhenry/wp--mr-interactive';

customElements.define( 'mr-play-pause-toggle', MrPlayPauseToggle );
